import { ApolloClient } from '@apollo/client';
import { getApolloClient } from '../../../../../../src/shared/graphql/client';
import { AB_TEST_QUERY } from './abTest.query';
import { GetAbTestsQuery } from './abTest.generated';
import { logError } from '@zoopla/logger';

export type ABTests = Record<string, string>;

export const getABTests = async (
    client?: ApolloClient<unknown>
): Promise<Record<string, string> | null> => {
    const c = client ?? getApolloClient();
    const {
        data: { abTests },
        errors
    } = await c.query<GetAbTestsQuery>({
        query: AB_TEST_QUERY
    });

    if (errors) {
        logError(errors);
    }

    return (
        abTests?.reduce((acc, { id, name }) => ({ ...acc, [id]: name }), {}) ??
        null
    );
};
